import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  Progress,
  NavLink,
  NavItem,
  Button,
  CardTitle,
  FormFeedback,
  FormText,
} from "reactstrap";
import classnames from "classnames";
import { Link, Navigate } from "react-router-dom";
import Async from 'react-select/async';
import Select from "react-select";
import { connect } from "react-redux";
import {
  clearCreateUserError,
  createUser,
  getFilteredStatesForAsyncSelect,
  getRetailersForAsyncSelect
} from "../../store/actions";
import {
  closeCreateZoneModal,
  getAssignableZonesForAsyncSelect,
  openCreateZoneModal
} from "../../store/zones/actions";
import {
  ORGANIZATION_ADMIN,
  PROFILE_ROLES_LIST,
  RETAILER,
  ROLE_PERMISSION_ORG_ADMIN,
  SUPER_ADMIN
} from "../../store/users/role.constants";
import { getUsersOrganisationsForAsyncSelect } from "../../store/organisation/actions";
import Message from "../../CommonData/Data/Message";
import { clearForm, updateForm } from "../../store/form/actions";
import FormValidator from '../../helper/formValidator';
import AddZone from "../Zones/AddZone";
import VWModel from "../../components/vwModal/vwModal";
import VWLoading from "../../components/vwLoading/vwLoading";

const customStyle = {
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#0bb197',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'white',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'white',
    ':hover': {
      backgroundColor: '#ff3d60',
      color: 'white',
    },
  }),
}

const FormWizard = (props) => {

  const { form, errorMessage, isPending, currentProfile } = props || {};
  const [activeTabwiz, setoggleTabwiz] = useState(1);
  const [passedStepswiz, setpassedStepswiz] = useState([1]);
  const [new_user_role, setNewUserRole] = useState();
  const [new_user_organisation, setNewUserOrg] = useState();
  const [isNotify, setIsNotify] = useState(true);
  const [selected_state, setState] = useState();
  const [selected_zone, setZone] = useState();
  const [refresh, setRefresh] = useState(0);
  const [mfgFilter, setMfgFilter] = useState();
  const [selectedRolePermission, setSelectedRolePermission] = useState([]);

  useEffect(() => {
    const { updateForm, clearForm, clearCreateUsersError } = props || {};
    updateForm({
      formAddUser: {
        formAddUser1: {},
        formAddUser2: {},
        formAddUser3: { isNotify: true },
        errors1: {},
        errors2: {},
        errors3: {}
      }
    })

    clearCreateUsersError();
    return () => {
      clearCreateUsersError();
      clearForm();
    }
  }, [])

  //---------------------TAB-1---------------------------------------------------------------------------
  const handleInputChange1 = (event) => {
    const { name, value } = event.target;
    let result = {};
    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      result = {
        isValid: emailRegex.test(value),
        message: 'Enter valid email',
      }
    }
    else if (name === 'mobileNumber') {
      const contactNumberRegex = /^\d{10}$/;
      result = {
        isValid: contactNumberRegex.test(value),
        message: 'Enter valid mobile number',
      };
    }
    else {
      result = FormValidator.validate(event.target);
    }

    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser1: {
          ...form.formAddUser.formAddUser1,
          [name]: value
        },
        errors1: {
          ...form && form.formAddUser.errors1,
          [name]: result.isValid ? null : result.message,
        }
      }
    });
  }

  //---------------------TAB-2---------------------------------------------------------------------------
  const handleInputChange2 = (event) => {
    const { name, value } = event.target;
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser2: {
          ...form.formAddUser.formAddUser2,
          [name]: value
        },
        errors2: {
          ...form && form.formAddUser.errors2,
          [name]: null,
        }
      }
    });
  }

  const handleLoadStates = (inputValue, callback) => {
    props.getFilteredStatesForAsyncSelect(inputValue, callback);
  };

  const handleLoadZones = (inputValue, callback) => {
    props.getAssignableZonesForAsyncSelect(inputValue, callback);
  };

  const handleRefreshZones = () => {
    setRefresh(refresh + 1)
  };

  const handleStateChange = (value) => {
    setState(value);
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser2: {
          ...form.formAddUser.formAddUser2,
          selected_state: value ? value.value : "",
        },
        errors2: {
          ...form && form.formAddUser.errors2,
          selected_state: null,
        }
      }
    });
  }

  const handleZoneChange = (value) => {
    setZone(value);
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser2: {
          ...form.formAddUser && form.formAddUser.formAddUser2,
          selected_zone: value ? value.value : "",
        },
        errors2: {
          ...form && form.formAddUser.errors2,
          selected_zone: null,
        }
      }
    });
  }

  const handleOpenCreateZone = () => {
    const { openCreateZoneModal } = props;
    openCreateZoneModal();
  };

  const handleClose = () => {
    const { closeCreateZoneModal } = props;
    closeCreateZoneModal();
  };

  //---------------------TAB-3--------------------------------------------------------------------------
  const currentRole = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0])

  const handleLoadOrganisation = (inputValue, callback) => {
    const isSuperAdmin = currentProfileRoles.length > 0 && currentProfileRoles[0].roleKey === SUPER_ADMIN;
    if (!isSuperAdmin) {
      return callback();
    }
    if (mfgFilter) {
      props.getOrganisationsForAsyncSelect(mfgFilter, inputValue, callback);
    }
    else {
      callback([]);
    }
  };

  const handleLoadRetailer = (inputValue, callback) => {
    const organisation = currentRole.orgId;
    if (organisation) {
      props.getRetailersForAsyncSelect(organisation, inputValue, callback);
    }
    else {
      callback([]);
    }
  };

  const handleAddUserRoleChange = (value) => {
    const new_role = !Array.isArray(value) ? value : {};
    setNewUserRole(new_role);
    if (!isSuperAdmin) {
      setNewUserOrg({
        label: currentRole.orgName,
        value: currentRole.orgId,

      });
    };
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          new_user_role: new_role,
          new_user_organisation: !isSuperAdmin ? currentRole.orgId : (new_user_organisation || null),
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          new_user_role: null,
        }
      }
    });
  }

  useEffect(() => {
    const selectedRole = new_user_role && new_user_role.value;
    if (selectedRole === "Manufacturer") {
      setMfgFilter('manufacturer');
      // handleLoadOrganisation();
    }
    else {
      setMfgFilter("admin");
      // handleLoadOrganisation();
    }
  }, [new_user_role])

  const handleAddUserOrgChange = (value) => {
    setNewUserOrg(value);
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          new_user_organisation: value ? value.value : ""
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          new_user_organisation: null,
        }
      }
    });
  };

  const handleAddUserRetailerChange = (value) => {
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          new_retailer: value
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          new_retailer: null,
        }
      }
    });
  };

  const handleRolePermission = (options) => {
    setSelectedRolePermission(options);
    const selectedRoles = options && options.map((i) => i.value);
    const roleString = selectedRoles.join(",")
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          RolePermissions: roleString,
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          RolePermissions: null,
        }
      }
    });
  }

  const handleNotificationStatusChange = () => {
    props.updateForm({
      formAddUser: {
        ...form.formAddUser,
        formAddUser3: {
          ...form.formAddUser.formAddUser3,
          isNotify: !isNotify
        },
        errors3: {
          ...form && form.formAddUser.errors3,
          isNotify: null,
        }
      }
    });
    setIsNotify(!isNotify);
  };

  //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
  const toggleTabwiz = (tab) => {
    const { formAddUser } = form || {};
    const { formAddUser1, formAddUser2, formAddUser3, errors1 } = formAddUser || {};
    const { firstName, lastName, displayName, mobileNumber, email } = formAddUser1 || {};
    const { addressLine1, selected_zone, selected_state, district, zip, town } = formAddUser2 || {};
    const { new_user_role, new_user_organisation, new_retailer } = formAddUser3 || {};


    let errors = {};
    const currentErrors1 = {};
    const currentErrors2 = {};
    const currentErrors3 = {};

    //---------------------TAB-1-----------------------------------------------------------
    if (activeTabwiz === 1) {
      if (!firstName) {
        currentErrors1.firstName = "First name is required"
      }
      if (!lastName) {
        currentErrors1.lastName = "Last name is required"
      }
      if (!displayName) {
        currentErrors1.displayName = "Display name is required"
      }
      if (!mobileNumber) {
        currentErrors1.mobileNumber = "Mobile number is required"
      }
      if (errors1 && errors1.mobileNumber) {
        currentErrors1.mobileNumber = "Enter valid mobile number"
      }
      if (!email) {
        currentErrors1.email = "Email is required"
      }
      if (errors1 && errors1.email) {
        currentErrors1.email = "Enter valid email"
      }

      props.updateForm({
        formAddUser: {
          ...form.formAddUser,
          formAddUser1: {
            ...form.formAddUser.formAddUser1,
          },
          errors1: currentErrors1,
        }
      })

      errors = currentErrors1;
    }
    //---------------------TAB-2-----------------------------------------------------------

    if (activeTabwiz === 2) {
      if (!addressLine1) {
        currentErrors2.addressLine1 = "Address is required"
      }
      if (!selected_zone) {
        currentErrors2.selected_zone = "Zone is required"
      }
      if (!selected_state) {
        currentErrors2.selected_state = "State is required"
      }
      if (!district) {
        currentErrors2.district = "District is required"
      }
      if (!town) {
        currentErrors2.town = "Town is required"
      }
      if (!zip) {
        currentErrors2.zip = "Zip is required"
      }
      props.updateForm({
        formAddUser: {
          ...form.formAddUser,
          formAddUser2: {
            ...form.formAddUser.formAddUser2,
          },
          errors2: currentErrors2,
        }
      })

      errors = currentErrors2
    }
    //---------------------TAB-3-----------------------------------------------------------
    if (activeTabwiz === 3) {
      if (!new_user_role) {
        currentErrors3.new_user_role = "Role is required"
      }
      if (!new_user_organisation && isSuperAdmin) {
        currentErrors3.new_user_organisation = "Organization is required"
      }
      if (isRoleSelected && (new_user_role && new_user_role.value === "EndUser") && !isRetailer && new_user_organisation && !new_retailer) {
        currentErrors3.new_retailer = "Retailer is required"
      }
      props.updateForm({
        formAddUser: {
          ...form.formAddUser,
          formAddUser3: {
            ...form.formAddUser.formAddUser3,
          },
          errors3: currentErrors3,
        }
      })

      errors = currentErrors3
    }
    if (Object.keys(errors).length === 0) {
      if (activeTabwiz !== tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (tab >= 1 && tab <= 4) {
          setoggleTabwiz(tab);
          setpassedStepswiz(modifiedSteps);
        }
      }
    }
    else {
      if (activeTabwiz > tab) {
        var modifiedSteps = [...passedStepswiz, tab];
        if (tab >= 1 && tab <= 4) {
          setoggleTabwiz(tab);
          setpassedStepswiz(modifiedSteps);
        }
      }
    }
  }

  //---------------------ROLES-------------------------------------------------------------------------
  const { roles, rolePermissions } = props.currentProfile || {};
  const currentProfileRoles = roles || [];
  const isRoleSelected = typeof new_user_role === "object" && new_user_role.name;
  const isSuperAdmin = currentProfileRoles.length > 0 && currentProfileRoles[0].roleKey === SUPER_ADMIN;
  const isOrgAdmin = currentProfileRoles.length > 0 && currentProfileRoles[0].roleKey === ORGANIZATION_ADMIN;
  const isRetailer = currentProfileRoles.length > 0 && currentProfileRoles[0].roleKey === RETAILER;

  let rolesPermitted;
  const rolesPermissionOption = [...ROLE_PERMISSION_ORG_ADMIN];

  const relevantUserRoles = currentProfileRoles.length > 0 ? currentProfileRoles[0].rank === 1 ? PROFILE_ROLES_LIST.filter((role) =>
    role.roleLevel <= 3 && role.roleLevel > currentProfileRoles[0].rank) : PROFILE_ROLES_LIST.filter((role) =>
      role.roleLevel > currentProfileRoles[0].rank) : [];

  if (isOrgAdmin) {
    const rolesApproved = rolePermissions;
    const rolesArray = rolesApproved && rolesApproved.split(',');
    const rolesNeedToDelete = rolesPermissionOption && rolesPermissionOption.filter((i) => !(rolesArray && rolesArray.includes(i.value)))
    const finalRoles = rolesNeedToDelete && rolesNeedToDelete.map((i) => i.label);
    rolesPermitted = relevantUserRoles.filter((i) => !(finalRoles && finalRoles.includes(i.label)));
  }
  //---------------------USER CREATE FORM SUBMISSION----------------------------------------------------
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      ...form.formAddUser.formAddUser1,
      ...form.formAddUser.formAddUser2,
      ...form.formAddUser.formAddUser3,
    }
    await props.createUser(data);
  };

  return props.isSuccess ? (<Navigate to="/userlist" />) : (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardTitle className='p-2 pb-0 d-flex justify-content-between align-items-center border-bottom border-secondary'>
                  <h5 className="fw-bold">CREATE USER</h5>
                  <Link to='/userlist' className="text-dark">
                    <i className="mdi mdi-close fs-2 me-2"></i>
                  </Link>
                </CardTitle>
                <CardBody>
                  {errorMessage && (
                    <div >
                      <Message
                        type="danger"
                        defaultMessage={errorMessage}
                        baseClassName="alert"
                      />
                    </div>
                  )}
                  <div id="progrss-wizard" className="twitter-bs-wizard">
                    <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                      <NavItem className={classnames({ active: activeTabwiz === 1 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 1 }))}
                          onClick={() => toggleTabwiz(1)}>
                          <span className="step-number">01</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>User Details</span>
                        </NavLink>
                      </NavItem>
                      <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 2 }))}
                          onClick={() => toggleTabwiz(2)}>
                          <span className="step-number">02</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>Communication Details</span>
                        </NavLink>
                      </NavItem>
                      <NavItem className={classnames({ active: activeTabwiz === 3 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 3 }))}
                          onClick={() => toggleTabwiz(3)}>
                          <span className="step-number">03</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>Role & Notification Details</span>
                        </NavLink>
                      </NavItem>
                      <NavItem className={classnames({ active: activeTabwiz === 4 })}>
                        <NavLink
                          className={(classnames({ active: activeTabwiz === 4 }))}
                          onClick={() => toggleTabwiz(4)}>
                          <span className="step-number">04</span>
                          <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm Details</span>
                        </NavLink>
                      </NavItem>
                    </ul>
                    <div id="bar" className="mt-4 mb-4">
                      <Progress
                        value={25 * activeTabwiz}
                        color="success"
                        animated
                      />
                    </div>
                    <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                      <TabPane tabId={1}>
                        <Form>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-firstname-input1">
                                  First Name
                                </Label><span className="text-danger">*</span>
                                <Input
                                  autoFocus
                                  type="text"
                                  className="form-control"
                                  id="basicpill-firstname-input1"
                                  name="firstName"
                                  placeholder="Enter first name"
                                  onChange={handleInputChange1}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.firstName}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.firstName}
                                </FormFeedback>
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-lastname-input2">
                                  Last Name
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="basicpill-lastname-input2"
                                  name="lastName"
                                  placeholder="Enter last name"
                                  onChange={handleInputChange1}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.lastName}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.lastName}
                                </FormFeedback>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-phoneno-input3">
                                  Display Name
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="displayName"
                                  id="basicpill-phoneno-input3"
                                  placeholder="Enter display name"
                                  onChange={handleInputChange1}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.displayName}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.displayName}
                                </FormFeedback>
                              </div>
                            </Col>
                            <Col lg="6">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-address-input1">
                                  Mobile Number
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="text"
                                  name="mobileNumber"
                                  className="form-control"
                                  id="basicpill-email-input4"
                                  placeholder="Enter mobile number"
                                  onChange={handleInputChange1}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.mobileNumber}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.mobileNumber}
                                </FormFeedback>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="12">
                              <div className="mb-3">
                                <Label htmlFor="basicpill-email-input4">
                                  Email
                                </Label><span className="text-danger">*</span>
                                <Input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  id="basicpill-email-input4"
                                  placeholder="Enter email"
                                  onChange={handleInputChange1}
                                  invalid={form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.email}
                                />
                                <FormFeedback>
                                  {form && form.formAddUser
                                    && form.formAddUser.errors1 &&
                                    form.formAddUser.errors1.email}
                                </FormFeedback>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </TabPane>
                      <TabPane tabId={2}>
                        <div>
                          <Form>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-pancard-input5">
                                    Address Line1
                                  </Label><span className="text-danger">*</span>
                                  <Input
                                    type="textarea"
                                    name="addressLine1"
                                    className="form-control"
                                    id="basicpill-pancard-input5"
                                    placeholder="Enter address"
                                    onChange={handleInputChange2}
                                    invalid={form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.addressLine1}
                                  />
                                  <FormFeedback>
                                    {form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.addressLine1}
                                  </FormFeedback>
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-pancard-input5">
                                    Address Line2
                                  </Label>
                                  <textarea
                                    type="text"
                                    name="addressLine2"
                                    className="form-control"
                                    id="basicpill-pancard-input5"
                                    placeholder="Enter address"
                                    onChange={handleInputChange2}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between">
                                    <Label htmlFor="basicpill-address-input12 ">
                                      Zone<span className="text-danger">*</span>
                                    </Label>
                                    <div>
                                      {(isOrgAdmin || isSuperAdmin) &&
                                        <Link
                                          type="button"
                                          className="mb-1"
                                          onClick={handleOpenCreateZone}
                                        >
                                          Add Zone
                                        </Link>
                                      }
                                      <Button
                                        color='link'
                                        size='sm'
                                        className="ms-2"
                                        onClick={handleRefreshZones}
                                      >
                                        <i class="fas fa-sync-alt"></i>
                                      </Button>
                                    </div>
                                  </div>
                                  <Async
                                    key={refresh}
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: (form && form.formAddUser
                                          && form.formAddUser.errors2 &&
                                          form.formAddUser.errors2.selected_zone) ? '#ff3d60' : "#CED4DA"
                                      })
                                    }}
                                    placeholder="Select zone"
                                    isSearchable
                                    defaultOptions
                                    menuPortalTarget={document.body}
                                    loadOptions={handleLoadZones}
                                    onChange={handleZoneChange}
                                    value={selected_zone}
                                  />
                                  {(form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.selected_zone) &&
                                    <FormText sx={{ marginLeft: "10px" }}>
                                      <div className="text-danger">
                                        {form && form.formAddUser
                                          && form.formAddUser.errors2 &&
                                          form.formAddUser.errors2.selected_zone}
                                      </div>
                                    </FormText>
                                  }
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-servicetax-input8">
                                    State
                                  </Label><span className="text-danger">*</span>
                                  <Async
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: (form && form.formAddUser
                                          && form.formAddUser.errors2 &&
                                          form.formAddUser.errors2.selected_state) ? '#ff3d60' : "#CED4DA"
                                      })
                                    }}
                                    placeholder="Select state"
                                    defaultOptions
                                    menuPortalTarget={document.body}
                                    loadOptions={handleLoadStates}
                                    onChange={handleStateChange}
                                    value={selected_state}
                                  />
                                  {(form && form.formAddUser
                                    && form.formAddUser.errors2 &&
                                    form.formAddUser.errors2.selected_state) &&
                                    <FormText sx={{ marginLeft: "10px" }}>
                                      <div className="text-danger">
                                        {form && form.formAddUser
                                          && form.formAddUser.errors2 &&
                                          form.formAddUser.errors2.selected_state}
                                      </div>
                                    </FormText>
                                  }
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-companyuin-input9">
                                    District
                                  </Label><span className="text-danger">*</span>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    name="district"
                                    id="basicpill-companyuin-input9"
                                    placeholder="Enter district"
                                    onChange={handleInputChange2}
                                    invalid={form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.district}
                                  />
                                  <FormFeedback>
                                    {form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.district}
                                  </FormFeedback>
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-declaration-input10">
                                    Town<span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="town"
                                    className="form-control"
                                    id="basicpill-Declaration-input10"
                                    placeholder="Enter town"
                                    onChange={handleInputChange2}
                                    invalid={form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.town}
                                  />
                                  <FormFeedback>
                                    {form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.town}
                                  </FormFeedback>
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label htmlFor="basicpill-declaration-input10">
                                    Zip
                                  </Label><span className="text-danger">*</span>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    name="zip"
                                    id="basicpill-Declaration-input10"
                                    placeholder="Enter zip"
                                    onChange={handleInputChange2}
                                    invalid={form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.zip}
                                  />
                                  <FormFeedback>
                                    {form && form.formAddUser
                                      && form.formAddUser.errors2 &&
                                      form.formAddUser.errors2.zip}
                                  </FormFeedback>
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                      </TabPane>
                      <TabPane tabId={3}>
                        <div>
                          <Form>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <div
                                    className={
                                      isRetailer || (new_user_role && new_user_role.id !== "EndUser")
                                        ? "col-xl-12"
                                        : "col-xl-12"
                                    }>
                                    <Label htmlFor="basicpill-namecard-input112">
                                      Role
                                    </Label><span className="text-danger">*</span>
                                    <Select
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: (form && form.formAddUser
                                            && form.formAddUser.errors3 &&
                                            form.formAddUser.errors3.new_user_role) ? '#ff3d60' : "#CED4DA"
                                        })
                                      }}
                                      backspaceRemovesValue={false}
                                      placeholder="Select role"
                                      isSearchable={true}
                                      options={!isOrgAdmin ? relevantUserRoles : rolesPermitted}
                                      onChange={handleAddUserRoleChange}
                                    />
                                    {(form && form.formAddUser
                                      && form.formAddUser.errors3 &&
                                      form.formAddUser.errors3.new_user_role) &&
                                      <FormText sx={{ marginLeft: "10px" }}>
                                        <div className="text-danger">
                                          {form && form.formAddUser
                                            && form.formAddUser.errors3 &&
                                            form.formAddUser.errors3.new_user_role}
                                        </div>
                                      </FormText>
                                    }
                                  </div>
                                </FormGroup>
                              </Col>
                              {isRoleSelected && (
                                <Col lg="6">
                                  <div
                                    className={
                                      isRetailer ||
                                        (new_user_role && new_user_role.id !== "role")
                                        ? "col-xl-12"
                                        : "col-xl-12"
                                    }
                                  >
                                    <FormGroup>
                                      <Label >
                                        Organization<span className="text-danger">*</span>
                                      </Label>
                                      <Async
                                        key={mfgFilter}
                                        styles={{
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                          control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor: (form && form.formAddUser
                                              && form.formAddUser.errors3 &&
                                              form.formAddUser.errors3.new_user_organisation) ? '#ff3d60' : "#CED4DA"
                                          })
                                        }}
                                        placeholder="Select organization"
                                        isDisabled={!isSuperAdmin}
                                        defaultOptions
                                        menuPortalTarget={document.body}
                                        loadOptions={handleLoadOrganisation}
                                        onChange={handleAddUserOrgChange}
                                        openMenuOnFocus={true}
                                        defaultValue={isSuperAdmin ? null : new_user_organisation}
                                      />
                                      {(form && form.formAddUser
                                        && form.formAddUser.errors3 &&
                                        form.formAddUser.errors3.new_user_organisation) &&
                                        <FormText sx={{ marginLeft: "10px" }}>
                                          <div className="text-danger">
                                            {form && form.formAddUser
                                              && form.formAddUser.errors3 &&
                                              form.formAddUser.errors3.new_user_organisation}
                                          </div>
                                        </FormText>
                                      }
                                    </FormGroup>
                                  </div>
                                </Col>
                              )}
                              {isRoleSelected && new_user_role.value === "EndUser" && !isRetailer && new_user_organisation && (
                                <Col lg="6">
                                  <div className={isRetailer ? "col-xl-12" : "col-xl-12"}>
                                    <FormGroup>
                                      <Label>
                                        Retailer<span className="text-danger">*</span>
                                      </Label>
                                      <Async
                                        styles={{
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                          control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor: (form && form.formAddUser
                                              && form.formAddUser.errors3 &&
                                              form.formAddUser.errors3.new_retailer) ? '#ff3d60' : "#CED4DA"
                                          })
                                        }}
                                        isSearchable
                                        key={new_user_organisation.value}
                                        name="new_retailer"
                                        placeholder="Select retailer"
                                        defaultOptions
                                        menuPortalTarget={document.body}
                                        loadOptions={handleLoadRetailer}
                                        onChange={handleAddUserRetailerChange}
                                        openMenuOnFocus={true}
                                      />
                                      {(form && form.formAddUser
                                        && form.formAddUser.errors3 &&
                                        form.formAddUser.errors3.new_retailer) &&
                                        <FormText sx={{ marginLeft: "10px" }}>
                                          <div className="text-danger">
                                            {form && form.formAddUser
                                              && form.formAddUser.errors3 &&
                                              form.formAddUser.errors3.new_retailer}
                                          </div>
                                        </FormText>
                                      }
                                    </FormGroup>
                                  </div>
                                </Col>
                              )}
                              {(isSuperAdmin && (new_user_role && new_user_role.value === "OrgAdmin")) &&
                                <Col lg='6'>
                                  <FormGroup>
                                    <Label>
                                      Allowed Roles To Be Created By Organization Admin
                                    </Label>
                                    <Select
                                      styles={customStyle}
                                      isMulti
                                      isSearchable
                                      placeholder='Select role'
                                      options={ROLE_PERMISSION_ORG_ADMIN}
                                      onChange={handleRolePermission}
                                      value={selectedRolePermission}
                                    />
                                    <FormText> <strong>Note : </strong>Organization admin will be able to create only the selected role users.</FormText>
                                  </FormGroup>
                                </Col>
                              }
                              <div>
                                <Col lg="6">
                                  <FormGroup className="mb-3">
                                    <Label>Notification</Label>
                                    <p>You can enable or disable a notification for the user.</p>
                                    <ul className="form-unstyled-list form-status-list mt-2">
                                      <li
                                        onClick={handleNotificationStatusChange}
                                        className={`form-status-item ${!isNotify ? "active" : ""}`}
                                      >
                                        Disable
                                      </li>
                                      <li
                                        onClick={handleNotificationStatusChange}
                                        className={`form-status-item ${isNotify ? "active" : ""}`}
                                      >
                                        Enable
                                      </li>
                                    </ul>
                                  </FormGroup>
                                </Col>
                              </div>
                            </Row>
                          </Form>
                        </div>
                      </TabPane>
                      <TabPane tabId={4}>
                        {isPending ?
                          <VWLoading />
                          :
                          <div className="row justify-content-center">
                            <Col lg="12">
                              <div className="text-center">
                                <div className="mb-4">
                                  <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <div>
                                  <h5>Confirm Details</h5>
                                  <p className="text-muted">
                                    New user is going to create as per your inputs. Are you sure to create?
                                  </p>
                                </div>
                                <Button color="success" onClick={handleSubmit}>
                                  Submit
                                </Button>
                                <Link className="btn btn-danger ms-4" to='/userlist'>
                                  Cancel
                                </Link>
                              </div>
                            </Col>
                          </div>
                        }
                      </TabPane>
                    </TabContent>
                    <ul className="pager wizard twitter-bs-wizard-pager-link">
                      <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                        {activeTabwiz !== 1 && <Button
                          color='primary'
                          onClick={() => toggleTabwiz(activeTabwiz - 1)}
                          disabled={activeTabwiz === 1}>
                          Previous
                        </Button>
                        }
                      </li>
                      <li className={activeTabwiz === 4 ? "next disabled" : "next"}>
                        {activeTabwiz !== 4 && <Button
                          color='primary'
                          onClick={() => toggleTabwiz(activeTabwiz + 1)}
                          disabled={activeTabwiz === 4}>
                          Next
                        </Button>
                        }
                        <div>
                          {props.status === "pending" && <div>Loading...</div>}
                          {props.status === "success" && <Navigate to="/userlist" />}
                          {props.status === "error" && (
                            <div>
                              {props.error}
                              <br />
                              <button onClick={() => handleSubmit()}>
                                Retry submission
                              </button>
                            </div>
                          )}
                        </div>
                        {/* )} */}
                      </li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <VWModel
          header="ADD ZONE"
          isOpen={props.isCreateZoneModalOpen}
          handleClose={handleClose}
        >
          <AddZone handleClose={handleClose} />
        </VWModel>
      </div>
    </React.Fragment >
  );
};

const mapStateToProps = (state) => ({
  Addform: state.users.Addform,
  isCreateZoneModalOpen: state.zones.isCreateZoneModalOpen,
  currentProfile: state.login.currentProfile,
  errorMessage: state.users.errorMessage,
  data: state.users.data,
  status: state.users.status,
  isSuccess: state.users.isCreateSuccess,
  error: state.users.error,
  isPending: state.users.isPending,
  form: state.form.form,
});

const mapDispatchToProps = (dispatch) => ({
  updateForm: (AddUser) => dispatch(updateForm(AddUser)),
  clearForm: () => dispatch(clearForm()),
  openCreateZoneModal: () => dispatch(openCreateZoneModal()),
  closeCreateZoneModal: () => dispatch(closeCreateZoneModal()),
  createUser: (data) => dispatch(createUser(data)),
  clearCreateUsersError: () => dispatch(clearCreateUserError()),
  getOrganisationsForAsyncSelect: (mfgFilter, searchValue, callback) => dispatch(getUsersOrganisationsForAsyncSelect(mfgFilter, searchValue, callback)),
  getAssignableZonesForAsyncSelect: (searchValue, callback) => dispatch(getAssignableZonesForAsyncSelect(searchValue, callback)),
  getFilteredStatesForAsyncSelect: (searchValue, callback) => dispatch(getFilteredStatesForAsyncSelect(searchValue, callback)),
  getRetailersForAsyncSelect: (orgId, searchValue, callback) => dispatch(getRetailersForAsyncSelect(orgId, searchValue, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);
